import { AllAemRoleIds, AllAffiliationRoleIds } from "@/constants/userRoles";
import { RouteRecordRaw } from "vue-router";
export default [
  {
    path: "/aem/dashboard",
    redirect: "/aem/manage-schools",
    component: () => import(/* webpackChunkName: 'AemDashboard' */ "@/views/aem/AemDashboard.vue"),
    name: "AemDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/manage-omr-uploads",
    component: () =>
      import(/* webpackChunkName: 'ManageOmrUploads' */ "@/views/aem/ManageOmrUploads.vue"),
    name: "ManageOmrUploads",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
      showAffiliationSelector: true,
    },
  },
  {
    path: "/aem/school-academic-plan",
    component: () =>
      import(/* webpackChunkName: 'SchoolAcademicPlan' */ "@/views/aem/SchoolAcademicPlan.vue"),
    name: "SchoolAcademicPlan",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/manage-schools",
    component: () =>
      import(/* webpackChunkName: 'ManageSchools' */ "@/views/aem/ManageSchools.vue"),
    name: "ManageSchools",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/onboard-new-school",
    component: () =>
      import(/* webpackChunkName: 'OnboardNewSchool' */ "@/views/aem/OnboardNewSchool.vue"),
    name: "OnboardNewSchool",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/offline-test-subject-wise-reports",
    component: () =>
      import(
        /* webpackChunkName: 'OfflineTestSubjectWiseReports' */ "@/views/aem/OfflineTestSubjectWiseReports.vue"
      ),
    name: "OfflineTestSubjectWiseReports",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
      showAffiliationSelector: true,
    },
  },
  {
    path: "/aem/publish-test-series",
    component: () =>
      import(/* webpackChunkName: 'PublishTestSeries' */ "@/views/aem/PublishTestSeries.vue"),
    name: "PublishTestSeries",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
      showAffiliationSelector: true,
    },
  },
  {
    path: "/aem/school-detailed-review",
    component: () =>
      import(/* webpackChunkName: 'SchoolDetailedReview' */ "@/views/aem/SchoolDetailedReview.vue"),
    name: "SchoolDetailedReview",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds.concat(AllAffiliationRoleIds),
    },
  },
  {
    path: "/aem/manage-school-users",
    component: () =>
      import(/* webpackChunkName: 'ManageSchoolUsers' */ "@/views/aem/ManageSchoolUsers.vue"),
    name: "ManageSchoolUsers",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/batch-teacher-mapping",
    component: () =>
      import(/* webpackChunkName: 'BatchTeacherMapping' */ "@/views/aem/BatchTeacherMapping.vue"),
    name: "BatchTeacherMapping",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/school-connects",
    component: () =>
      import(/* webpackChunkName: 'SchoolConnects' */ "@/views/aem/SchoolConnects.vue"),
    name: "SchoolConnects",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },

  {
    path: "/aem/school-monthly-meetings",
    component: () =>
      import(
        /* webpackChunkName: 'SchoolMonthlyMeetings' */ "@/views/aem/SchoolMonthlyMeetings.vue"
      ),
    name: "SchoolMonthlyMeetings",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },

  {
    path: "/aem/school-pdf-reports",
    component: () =>
      import(/* webpackChunkName: 'SchoolPdfReports' */ "@/views/aem/SchoolPdfReports.vue"),
    name: "SchoolPdfReports",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
  {
    path: "/aem/school-queries",
    component: () =>
      import(/* webpackChunkName: 'SchoolQueries' */ "@/views/aem/SchoolQueries.vue"),
    name: "SchoolQueries",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllAemRoleIds,
    },
  },
] as unknown as Array<RouteRecordRaw>;
